import { render, staticRenderFns } from "./jxsyjfx.vue?vue&type=template&id=0cf62c3e&"
import script from "./jxsyjfx.vue?vue&type=script&lang=js&"
export * from "./jxsyjfx.vue?vue&type=script&lang=js&"
import style0 from "./jxsyjfx.vue?vue&type=style&index=0&id=0cf62c3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports